import { render, staticRenderFns } from "./TransformationAttributes.vue?vue&type=template&id=48517177"
import script from "./TransformationAttributes.vue?vue&type=script&lang=js"
export * from "./TransformationAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports